<template>
    <section class="table pb70">
        <div class="box">
            <div class="table__header">
                <h1>{{title}}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'projectList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>

            <div class="tabs">
                <button
                    class="tab"
                    :class="{ active: activeTab === 'generali' }"
                    @click="activeTab = 'generali'"
                >
                    Generali
                </button>

                <button
                    v-if="!hideCookieTab"
                    class="tab"
                    :class="{ active: activeTab === 'cookie' }"
                    @click="activeTab = 'cookie'"
                >
                    Cookie
                </button>

                <button
                    v-if="!hideCookieTab"
                    class="tab"
                    :class="{ active: activeTab === 'accessibilita' }"
                    @click="activeTab = 'accessibilita'"
                >
                    Accessibilità
                </button>

                <button
                    class="tab"
                    :class="{ active: activeTab === 'avanzate' }"
                    @click="activeTab = 'avanzate'"
                >
                    Avanzate
                </button>
            </div>

            <div class="table__form">
                <div v-if="this.$route.params.action === 'edit'" class="container_box_visit">
                    <div class="box_visit">
                        <h3>
                            <strong>Sito</strong>
                            <div :style="getDotStyle(project.status)"></div>
                        </h3>
                        <h3><strong>Prima visita:</strong> {{ project.firstVisit }}</h3>
                        <h3><strong>Ultima visita:</strong> {{ project.lastVisit }}</h3>
                    </div>

                    <div class="box_visit">
                        <h3>
                            <strong>BE</strong>
                            <div :style="getDotStyle(project.statusBe)"></div>
                        </h3>
                        <h3><strong>Prima visita:</strong> {{ project.firstVisitBe }}</h3>
                        <h3><strong>Ultima visita:</strong>  {{ project.lastVisitBe }}</h3>
                    </div>
                </div>


                <div v-show="activeTab === 'generali'" class="tab-panel">

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Attivo</strong>
                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_active"
                                type="checkbox"
                                :checked="project.active == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.active = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_active"></label>
                        </div>
                    </div>

                    <!-- <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Nome</strong>
                        </div>
                        <input type="text" v-model="project.project">
                    </div> -->

                    <div class="form_inline" style="display: flex;align-items: flex-start;gap: 20px;">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Nome</strong>
                        </div>

                        <div class="input-group" style="display: flex;flex-direction: column;flex: 1;">
                            <input type="text" v-model="project.project" style="width: 100%;">
                            <span class="existence-checker" style="color: red;padding: 15px 0px 0px 0px;" v-if="nameExists">Nome già esistente</span>
                        </div>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Piattaforma</strong>
                        </div>
                        <select v-model="project.platform">
                            <option value="cube">Cube</option>
                            <option value="wp">Wordpress</option>
                            <option value="aec">Aec</option>
                            <option value="mentefredda">Z-Suite</option>
                            <option value="porting">Porting</option>
                        </select>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Versione</strong>
                        </div>
                        <select v-model="project.version">
                            <option value="all-in-one">All-in-one</option>
                            <option value="all-in-one-2023">All-in-one 2023</option>
                        </select>
                    </div>

                    <input v-model="project.consent_mode" type="hidden" />

                    <div class="multiple multiple--plain multiple--separator">
                        <h2>Lista Siti</h2>

                        <div class="header-lista-sites">
                            <div>Active</div>
                            <div>Site</div>
                            <div></div>
                            <div></div>
                        </div>

                        <div v-for="(site, siteIndex) in sites" :key="'site-' + (site.id !== undefined ? site.id : siteIndex) + '-' + siteIndex">
                            <div v-if="!site.deleted">
                                <div class="flex_sites" :class="{ 'site-has-expanded': expandedSites[siteIndex] }" :style="{ opacity: site.active == 0 ? 0.6 : 1 }">
                                    <select v-model="site.active">
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                    <span class="site-label" @click="toggleSiteExpand(siteIndex)">
                                        {{ site.site || '—' }}
                                    </span>
                                    <i :class="expandedSites[siteIndex] ? 'fal fa-chevron-up' : 'fal fa-chevron-down'"
                                       class="site-toggle-icon"
                                       @click="toggleSiteExpand(siteIndex)"></i>
                                    <i class="fal fa-trash-alt" v-on:click="deleteSite(siteIndex)"></i>
                                </div>

                                <transition
                                  :css="false"
                                  @before-enter="accordionBeforeEnter"
                                  @enter="accordionEnter"
                                  @after-enter="accordionAfterEnter"
                                  @before-leave="accordionBeforeLeave"
                                  @leave="accordionLeave"
                                  @after-leave="accordionAfterLeave"
                                >
                                <div v-if="expandedSites[siteIndex]">
                                    <div class="site-expanded-panel">
                                        <label class="site-field">
                                            <span>Site</span>
                                            <input type="text" v-model="site.site"
                                                @input="handleSiteInput(site, siteIndex)"
                                                @blur="flushSiteCheck(site, siteIndex)"
                                                placeholder="Site">
                                        </label>
                                        <label class="site-field">
                                            <span>Hotel Name</span>
                                            <input type="text" v-model="site.name" placeholder="Hotel Name" :class="{ 'input-error': siteNameRequiredError(siteIndex) }">
                                            <span v-if="siteNameRequiredError(siteIndex)" class="field-error-msg">Hotel Name è obbligatorio quando è presente un Folder</span>
                                        </label>
                                        <label class="site-field">
                                            <span>Folder</span>
                                            <input type="text" v-model="site.folder" placeholder="/Folder">
                                        </label>
                                        <label class="site-field">
                                            <span>BlastbookID</span>
                                            <input type="text" v-model="site.idBlastbook" placeholder="BlastbookID">
                                        </label>
                                        <label class="site-field">
                                            <span>AccommodationID</span>
                                            <input type="text" v-model="site.accommodationID" placeholder="AccommodationID">
                                        </label>
                                    </div>
                                    <div class="site-expanded-panel">
                                        <div class="site-field">
                                            <span>GTM Code</span>
                                            <input type="text" v-model="site.tags[0].id" placeholder="GTM-XXXXXXXX">
                                        </div>
                                        <div class="site-field">
                                            <span>GTM Load Type</span>
                                            <select v-model="site.tags[0].type_id">
                                                <option :value="null">Load</option>
                                                <option
                                                    v-for="(scriptType, currentIndex) in scriptTypes"
                                                    :key="'st-site-option-' + (scriptType.id !== undefined ? scriptType.id : currentIndex) + '-' + currentIndex"
                                                    :value="scriptType.id"
                                                    v-if="scriptType.translations.length > 0"
                                                >
                                                    {{ scriptType.translations[0].translation }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                </transition>
                            </div>
                            <div v-if="siteErrors[siteIndex]" style="display: flex;flex-direction: column;border: 1px solid #ddd;padding: 10px;margin-bottom: 10px;border-radius: 5px;">
                                <span class="existence-checker" style="color:red">{{ siteErrors[siteIndex] }}</span>
                            </div>
                        </div>
                        <div class="add_btn">
                            <input class="insert" type="button" value="Inserisci" v-on:click="addSite">
                        </div>
                    </div>

                    <div class="multiple multiple--plain">
                        <h2>Lista BE</h2>

                        <div class="header-lista-bookings">
                            <div>Active</div>
                            <div>Type</div>
                            <div>Name</div>
                            <div></div>
                            <div></div>
                        </div>

                        <div v-for="(booking, bookingIndex) in bookings" :key="'booking-' + (booking.id !== undefined ? booking.id : bookingIndex) + '-' + bookingIndex">
                            <div v-if="!booking.deleted">
                                <div class="flex_bookings" :class="{ 'booking-has-expanded': expandedBookings[bookingIndex] }" :style="{ opacity: booking.active == 0 ? 0.6 : 1 }">
                                    <div class="booking-col">
                                        <span class="col-label">Active</span>
                                        <select v-model="booking.active">
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                    </div>
                                    <div class="booking-col">
                                        <span class="col-label">Type</span>
                                        <select v-model="booking.type">
                                            <optgroup label="Vertical">
                                                <option value="id_albergo">Vertical Hotel</option>
                                                <option value="id_gruppo">Vertical Group</option>
                                                <option value="vertical_services">Vertical Servizi</option>
                                                <option value="vertical_vouchers">Vertical Voucher</option>
                                            </optgroup>
                                            <optgroup label="Blastness">
                                                <option value="hotel_code">Blastness Hotel</option>
                                                <option value="group_code">Blastness Group</option>
                                            </optgroup>
                                            <optgroup label="Ermes">
                                                <option value="ermes">Ermes Hotel</option>
                                                <option value="ermes_group">Ermes Group</option>
                                            </optgroup>
                                            <option value="hotel">Synxis Hotel</option>
                                        </select>
                                    </div>
                                    <span class="booking-label" @click="toggleBookingExpand(bookingIndex)">
                                        {{ booking.name || '—' }}
                                    </span>
                                    <i :class="expandedBookings[bookingIndex] ? 'fal fa-chevron-up' : 'fal fa-chevron-down'"
                                       class="booking-toggle-icon"
                                       @click="toggleBookingExpand(bookingIndex)"></i>
                                    <i class="fal fa-trash-alt" v-on:click="deleteBooking(bookingIndex)"></i>
                                </div>

                                <transition
                                  :css="false"
                                  @before-enter="accordionBeforeEnter"
                                  @enter="accordionEnter"
                                  @after-enter="accordionAfterEnter"
                                  @before-leave="accordionBeforeLeave"
                                  @leave="accordionLeave"
                                  @after-leave="accordionAfterLeave"
                                >
                                <div v-if="expandedBookings[bookingIndex]">
                                    <div class="booking-expanded-panel">
                                        <label class="booking-field">
                                            <span>Name</span>
                                            <input type="text" v-model="booking.name" placeholder="Name">
                                        </label>
                                        <label class="booking-field">
                                            <span>CrsID</span>
                                            <input type="text" v-model="booking.booking" placeholder="CrsID"
                                                @input="handleBeInput(booking, bookingIndex, 'CrsId')"
                                                @blur="flushBeCheck(booking, bookingIndex, 'CrsId')">
                                        </label>
                                        <label class="booking-field">
                                            <span>BlastbookID</span>
                                            <input type="text" v-model="booking.idBlastbook" placeholder="BlastbookID"
                                                @input="handleBeInput(booking, bookingIndex, 'BBID')"
                                                @blur="flushBeCheck(booking, bookingIndex, 'BBID')">
                                        </label>
                                        <label class="booking-field">
                                            <span>AccommodationID</span>
                                            <input type="text" v-model="booking.accommodationID" placeholder="AccommodationID"
                                                @input="handleBeInput(booking, bookingIndex, 'ACCID')"
                                                @blur="flushBeCheck(booking, bookingIndex, 'ACCID')">
                                        </label>
                                        <label class="booking-field">
                                            <span>Custom domain</span>
                                            <input type="text" v-model="booking.custom_domain" placeholder="Custom domain (es. book.trinityluxuryrooms.com)">
                                        </label>
                                    </div>
                                    <div class="booking-expanded-panel">
                                        <div class="booking-field">
                                            <span>GTM Code</span>
                                            <input type="text" v-model="booking.tags[0].id" placeholder="GTM-XXXXXXXX">
                                        </div>
                                        <div class="booking-field">
                                            <span>GTM Load Type</span>
                                            <select v-model="booking.tags[0].type_id">
                                                <option :value="null">Load</option>
                                                <option
                                                    v-for="(scriptType, currentIndex) in scriptTypes"
                                                    :key="'st-booking-option-' + (scriptType.id !== undefined ? scriptType.id : currentIndex) + '-' + currentIndex"
                                                    :value="scriptType.id"
                                                    v-if="scriptType.translations.length > 0"
                                                >
                                                    {{ scriptType.translations[0].translation }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                </transition>
                            </div>
                            <div v-if="beErrors[bookingIndex] && (beErrors[bookingIndex].CrsId || beErrors[bookingIndex].BBID || beErrors[bookingIndex].ACCID)" style="display: flex;flex-direction: column;border: 1px solid #ddd;padding: 10px;margin-bottom: 10px;border-radius: 5px;gap: 5px;">
                                <span class="existence-checker" v-if="beErrors[bookingIndex].CrsId" style="color:red">{{ beErrors[bookingIndex].CrsId }}</span>
                                <span class="existence-checker" v-if="beErrors[bookingIndex].BBID" style="color:red">{{ beErrors[bookingIndex].BBID }}</span>
                                <span class="existence-checker" v-if="beErrors[bookingIndex].ACCID" style="color:red">{{ beErrors[bookingIndex].ACCID }}</span>
                            </div>
                        </div>
                        <div class="add_btn">
                            <input class="insert" type="button" value="Inserisci" v-on:click="addBooking">
                        </div>
                    </div>

                </div>



                <div v-show="activeTab === 'avanzate'" class="tab-panel">

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Conversion offline</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Registra gli accessi da campagna e i push nel dataLayer con event =
                                    <code>'begin_checkout'</code> o <code>'purchase'</code>
                                </span>
                            </span>

                            <p v-if="project.requestLogOfflineConversion" style="margin-bottom: 0; color: #cb2390; font-style: italic;">({{project.requestLogOfflineConversion }})</p>

                            <div class="mt-10" v-if="hasPermission('Projects', 'chanel')">
                                <router-link
                                    class="button button-p"
                                    :to="{ name: 'projectChanel', params: { id: project.id } }"
                                >gestisci i canali</router-link>
                            </div>


                        </div>

                        <div>
                            <div class="checkbox-wrapper-6">
                                <input
                                    class="tgl tgl-light" id="cb_offline_conversion"
                                    type="checkbox"
                                    :checked="project.offline_conversion == 1"
                                    :disabled="isReadOnly('Projects', 'readonly')"
                                    @change="project.offline_conversion = $event.target.checked ? 1 : 0"
                                />
                                <label class="tgl-btn" for="cb_offline_conversion"></label>
                            </div>
                        </div>


                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Disabilita DRT</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Disabilita l'iniziezione dello script DRT
                                </span>
                            </span>

                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light"
                                :id="'cb_disable_drt_' + project.id"
                                type="checkbox"
                                :checked="project.disable_drt == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.disable_drt = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" :for="'cb_disable_drt_' + project.id"></label>
                        </div>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Inject Hotels Ads</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Inietta googletagmanager e al purchase fa un push "conversion" nel datalayer
                                </span>
                            </span>
                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_inject_ads"
                                type="checkbox"
                                :checked="project.inject_ads == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.inject_ads = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_inject_ads"></label>
                        </div>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Shadow banner website</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Nasconde il banner preferenze gdpr e previene l'inclusione degli script nel sito
                                </span>
                            </span>
                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_shadow_banner_website"
                                type="checkbox"
                                :checked="project.shadow_banner_website == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.shadow_banner_website = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_shadow_banner_website"></label>
                        </div>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Shadow banner be</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Nasconde il banner preferenze gdpr e previene l'inclusione degli script nel be
                                </span>
                            </span>

                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_shadow_banner_be"
                                type="checkbox"
                                :checked="project.shadow_banner_be == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.shadow_banner_be = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_shadow_banner_be"></label>
                        </div>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Consent mode version</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Versione consent mode v1 abilita tutti v2 in base alle preferenze
                                </span>
                            </span>
                        </div>
                        <select
                            :disabled="isReadOnly('Projects', 'readonly')"
                            v-model="project.consent_mode_version">
                            <option value="null">Disattiva</option>
                            <option value="v1">Versione 1</option>
                            <option value="v2">Versione 2</option>
                        </select>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Consent mode "ads_data_redaction"</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Determina il valore di ads_data_redaction
                                </span>
                            </span>
                        </div>
                        <select v-model="project.ads_data_redaction">
                            <option value="0">false</option>
                            <option value="1">true</option>
                        </select>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Enable navigation logs</strong>

                            <span class="info-icon">
                                <i class="fal fa-info-circle"></i>
                                <span class="tooltip">
                                    Determina il valore di ads_data_redactionabilita la registrazione delle informazione di navigazione degli utenti
                                </span>
                            </span>
                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_navigation_logs"
                                type="checkbox"
                                :checked="project.navigation_logs == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.navigation_logs = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_navigation_logs"></label>
                        </div>
                    </div>

                </div>


                <div v-show="activeTab === 'cookie'" class="tab-panel">
                    <div class="multiple">
                        <h2>Lista Scripts</h2>

                        <draggable :list="scriptsList" handle=".fa-arrows-alt-v" item-key="id">
                            <!-- uso v-for ma la key è id + index per garantire unicità anche se id duplicati -->
                            <div v-for="(script, scriptIndex) in scriptsList" :key="'script-' + (script.id !== undefined ? script.id : scriptIndex) + '-' + scriptIndex">
                                <div v-if="!script.deleted" class="flex_scripts" :style="{ opacity: script.active == 0 ? 0.6 : 1 }">
                                    <i class="fal fa-arrows-alt-v" v-if="!isReadOnly('Projects', 'readonly')" @click="deleteScript(scriptIndex)"></i>

                                    <select v-model="script.active" :disabled="isReadOnly('Projects', 'readonly')">
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>

                                    <select v-model="script.platform" :disabled="isReadOnly('Projects', 'readonly')">
                                        <option value="1">All platform</option>
                                        <option value="2">Web site</option>
                                        <option value="3">Booking</option>
                                    </select>

                                    <select v-model="script.type_id" :disabled="isReadOnly('Projects', 'readonly')">
                                        <option :value="null">Load</option>
                                        <option
                                            v-for="(scriptType, currentIndex) in scriptTypes"
                                            :key="'st-option-' + (scriptType.id !== undefined ? scriptType.id : currentIndex) + '-' + currentIndex"
                                            :value="scriptType.id"
                                            v-if="scriptType.translations.length > 0"
                                        >
                                            {{ scriptType.translations[0].translation }}
                                        </option>
                                    </select>

                                    <textarea v-model="script.script" :disabled="isReadOnly('Projects', 'readonly')"></textarea>

                                    <i class="fal fa-trash-alt" v-if="!isReadOnly('Projects', 'readonly')" @click="deleteScript(scriptIndex)"></i>
                                </div>
                            </div>
                        </draggable>

                        <div class="add_btn" v-if="!isReadOnly('Projects', 'readonly')">
                            <input class="insert" type="button" value="Inserisci" @click="addScript" />
                        </div>
                    </div>

                    <div class="multiple">
                        <h2>Cookie nel tuo progetto</h2>
                        <div v-for="(scriptType, stIndex) in scriptTypes" :key="'scriptType-' + (scriptType.id !== undefined ? scriptType.id : stIndex) + '-' + stIndex">
                            <div class="scriptType">
                                <div class="cat_scriptType" v-if="scriptType.translations.length > 0" @click="toggleScriptType(scriptType.id)" style="cursor: pointer;">
                                    {{scriptType.translations[0].translation}}

                                    <span style="margin-left: 10px; font-weight: normal;">
                                        ({{ scriptTypeLibraryCounts[scriptType.id] || 0 }} selezionat{{ scriptTypeLibraryCounts[scriptType.id] === 1 ? 'a' : 'e' }})
                                    </span>


                                    <i
                                        :class="collapsedScriptTypes.includes(scriptType.id)
                                        ? 'fal fa-chevron-down'
                                        : 'fal fa-chevron-up'"

                                        style="margin-left: 10px;"
                                    ></i>

                                </div>

                                <div  v-show="!collapsedScriptTypes.includes(scriptType.id)">
                                    <div v-for="(library, libIndex) in scriptType.libraries" :key="'lib-' + (library.id !== undefined ? library.id : libIndex) + '-' + libIndex">
                                        <div class="lib_scriptType">

                                            <div class="checkbox-wrapper-6">
                                                <input
                                                    class="tgl tgl-light"
                                                    type="checkbox"
                                                    :id="'library-' + library.id"
                                                    :value="library.id"
                                                    v-model="libraries"
                                                />
                                                <label class="tgl-btn" :for="'library-' + library.id"></label>
                                            </div>

                                            <label>{{library.library}}</label>
                                            <div v-if="library.supplier != ''" class="description description_col1" v-html="library.supplier"></div>
                                            <div v-if="library.translation != ''" class="description description_col2" v-html="library.translation"></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="multiple">
                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Link privacy</strong>
                            </div>
                            <div class="translations">
                                <ul class="change-languages">
                                    <!-- key unique: prefix + id + index -->
                                    <li
                                        v-for="(language, liIndex) in languages"
                                        :key="'flag-' + (language.id !== undefined ? language.id : liIndex) + '-' + liIndex"
                                        v-on:click="languageSelect(language.slug)"
                                        :class="(languageSelected == language.slug) ? 'selected' : ''"
                                    >
                                        <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                                    </li>
                                </ul>

                                <!-- inputs for languages: different key prefix so no duplication in DOM -->
                                <div
                                    v-for="(language, inpIndex) in languages"
                                    :key="'input-' + (language.id !== undefined ? language.id : inpIndex) + '-' + inpIndex"
                                >
                                    <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                        <input type="text" v-model="translations[language.id]['privacy']">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="activeTab === 'accessibilita'" class="tab-panel">

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Activate accessibility popup website</strong>
                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_accessibility_popup_website"
                                type="checkbox"
                                :checked="project.accessibility_popup_website == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.accessibility_popup_website = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_accessibility_popup_website"></label>
                        </div>
                    </div>

                    <div class="form_inline">
                        <div class="w-25 mr-2">
                            <strong class="label-form">Activate accessibility popup be</strong>
                        </div>
                        <div class="checkbox-wrapper-6">
                            <input
                                class="tgl tgl-light" id="cb_accessibility_popup_be"
                                type="checkbox"
                                :checked="project.accessibility_popup_be == 1"
                                :disabled="isReadOnly('Projects', 'readonly')"
                                @change="project.accessibility_popup_be = $event.target.checked ? 1 : 0"
                            />
                            <label class="tgl-btn" for="cb_accessibility_popup_be"></label>
                        </div>
                    </div>

                </div>

                <div class="bcm_action" style="display: flex; justify-content: space-between;">
                    <div>
                        <div><div><strong>Created</strong>: {{ project.requestLogCreate }}</div></div>
                        <div><div><strong>Updated</strong>: {{ project.requestLogUpade }}</div></div>
                    </div>
                    <input
                        type="button"
                        :value="btn"
                        :class="{ 'is-disabled': hasBlockingValidationErrors }"
                        v-on:click="saveProject()"
                    >
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import draggable from 'vuedraggable';
import _ from 'lodash';
import axios from 'axios';
import flagMixin from '../../../mixins/flagMixin';

// Tipologie di booking che rappresentano un "gruppo" invece di un singolo hotel.
// Un CrsID/BlastbookID/AccommodationID uguale non è considerato duplicato se
// appartiene ad un booking di gruppo da una parte e ad un booking singolo dall'altra.
const GROUP_BOOKING_TYPES = ['id_gruppo', 'group_code', 'ermes_group'];

export default {
    mixins: [flagMixin],
    data: () => ({
        title: 'Progetto',
        activeTab: "generali",
        collapsedScriptTypes: [],  // 👈 UI state locale
        nameExists: false,
        expandedSites: {},
        expandedBookings: {},
        siteErrors: [],
        siteCheckTimeouts: {},
        siteCheckRequestIds: {},
        beErrors: [],
        beCheckTimeouts: {},
        beCheckRequestIds: {}
    }),
    components: {
        draggable
    },
    computed: {
        ...mapGetters({
            project: 'projectsModule/project',
            languages: 'projectsModule/languages',
            languageSelected: 'projectsModule/languageSelected',
            translations: 'projectsModule/translations',
            hasPermission: 'hasPermission',
            isReadOnly: 'isReadOnly'
        }),
        ...mapMultiRowFields('projectsModule', ['sites', 'bookings', 'scriptTypes', 'scripts']),

        btn() {
            return this.$route.params.action === 'create' ? "Salva" : "Modifica";
        },

        // scriptsList: getter + setter corretto (commit con il valore)
        scriptsList: {
            get() {
                return this.$store.state.projectsModule.scripts;
            },
            set(val) {
                // commit con il nuovo ordine (val)
                this.$store.commit('projectsModule/updateScriptsOrder', val);
            }
        },

        libraries: {
            set(val) {
                // NB: se preferisci, usa una mutation invece di scrivere direttamente nello state
                this.$store.state.projectsModule.libraries = val;
            },
            get() {
                return this.$store.state.projectsModule.libraries;
            }
        },

        scriptTypeLibraryCounts() {
            const counts = {};
            const selectedIds = this.libraries.map(id => Number(id));
            this.scriptTypes.forEach(scriptType => {
                const libraries = scriptType.libraries || [];
                counts[scriptType.id] = libraries.filter(lib =>
                    selectedIds.includes(Number(lib.id))
                ).length;
            });
            return counts;
        },
        hasBlockingValidationErrors() {
            const hasSiteErrors = this.siteErrors.some(Boolean);
            const hasBeErrors = this.beErrors.some((bookingErrors) => {
                if (!bookingErrors) {
                    return false;
                }

                return Object.values(bookingErrors).some(Boolean);
            });
            const hasSiteNameErrors = this.sites.some((site, index) => this.siteNameRequiredError(index));

            if (this.$route.params.action === 'create') {
                return this.nameExists || hasSiteErrors || hasBeErrors || hasSiteNameErrors;
            }

            return hasSiteErrors || hasBeErrors || hasSiteNameErrors;
        },
        hideCookieTab() {
            return (
                this.project.shadow_banner_website == 1 &&
                this.project.shadow_banner_be == 1
            );
        }
    },

    methods: {
        accordionBeforeEnter(el) {
            el.style.maxHeight = '0';
            el.style.opacity = '0';
            el.style.overflow = 'hidden';
        },

        accordionEnter(el, done) {
            const h = el.scrollHeight;
            el.style.transition = 'max-height 0.25s ease, opacity 0.2s ease';
            el.style.maxHeight = h + 'px';
            el.style.opacity = '1';
            setTimeout(done, 250);
        },

        accordionAfterEnter(el) {
            el.style.maxHeight = '';
            el.style.overflow = '';
            el.style.transition = '';
            el.style.opacity = '';
        },

        accordionBeforeLeave(el) {
            // Il compact row perde la classe site/booking-has-expanded in modo sincrono
            // quando expandedSites/Bookings diventa false. Forziamo gli stili via inline
            // per mantenere l'aspetto "aperto" durante tutta la chiusura animata.
            const row = el.previousElementSibling;
            if (row) {
                el._compactRow = row;
                row.style.borderRadius = '5px 5px 0 0';
                row.style.marginBottom = '0';
            }
        },

        accordionLeave(el, done) {
            const h = el.scrollHeight;
            el.style.overflow = 'hidden';
            el.style.maxHeight = h + 'px';
            el.getBoundingClientRect(); // forza reflow per committare il valore di partenza
            el.style.transition = 'max-height 0.22s ease-in';
            el.style.maxHeight = '0';
            setTimeout(done, 250);
        },

        accordionAfterLeave(el) {
            // Ripristina il compact row al suo stato normale
            if (el._compactRow) {
                el._compactRow.style.borderRadius = '';
                el._compactRow.style.marginBottom = '';
                el._compactRow = null;
            }
            el.style.maxHeight = '';
            el.style.overflow = '';
            el.style.transition = '';
        },

        toggleSiteExpand(index) {
            const updated = { ...this.expandedSites };
            updated[index] = !updated[index];
            this.expandedSites = updated;
        },

        toggleBookingExpand(index) {
            const updated = { ...this.expandedBookings };
            updated[index] = !updated[index];
            this.expandedBookings = updated;
        },

        loadProject() {
            this._isLoadingProject = true;
            this.$store.dispatch('projectsModule/loadProject', { urlToConnect: 'projects/' + this.$route.params.id + '/edit', id: this.$route.params.id })
                .then(() => {
                    this._isLoadingProject = false;
                    this.checkAllExistingValues();
                });
        },

        async checkAllExistingValues() {
            // Costruisce un unico array di elementi da verificare (siti e booking) e lo invia
            // in una sola chiamata a /project-batch-exist, al posto di N chiamate separate.
            const sitesToCheck = [];
            this.sites.forEach((site, index) => {
                const siteValue = (!site.deleted && site.site) ? site.site.trim() : '';
                if (!siteValue) {
                    return;
                }

                // Lo stesso dominio può comparire più volte nello stesso progetto: se è già
                // presente in un altro sito della lista, nessun errore e nessuna verifica.
                const sameInList = this.sites.some((s, i) =>
                    i !== index &&
                    !s.deleted &&
                    s.site &&
                    s.site.trim().toLowerCase() === siteValue.toLowerCase()
                );
                if (sameInList) {
                    this.$set(this.siteErrors, index, false);
                    return;
                }

                sitesToCheck.push({ index, site: siteValue });
            });

            const bookingsToCheck = [];
            this.bookings.forEach((booking, index) => {
                if (booking.deleted) {
                    return;
                }
                const isGroup = GROUP_BOOKING_TYPES.includes(booking.type);
                if (booking.booking && booking.booking.trim()) bookingsToCheck.push({ index, type: 'CrsId', value: booking.booking.trim(), isGroup });
                if (booking.idBlastbook && booking.idBlastbook.trim()) bookingsToCheck.push({ index, type: 'BBID', value: booking.idBlastbook.trim(), isGroup });
                if (booking.accommodationID && booking.accommodationID.trim()) bookingsToCheck.push({ index, type: 'ACCID', value: booking.accommodationID.trim(), isGroup });
            });

            if (sitesToCheck.length === 0 && bookingsToCheck.length === 0) {
                return;
            }

            try {
                const res = await axios.post('/project-batch-exist', {
                    sites: sitesToCheck,
                    bookings: bookingsToCheck
                });

                const siteResults = res.data.sites || {};
                sitesToCheck.forEach(({ index, site }) => {
                    const result = siteResults[index] || { exists: false };
                    const isSameProject = result.exists && this.$route.params.action === 'edit' && String(result.project_id) === String(this.$route.params.id);
                    this.$set(this.siteErrors, index, (result.exists && !isSameProject)
                        ? 'Il dominio ' + site + ' è già usato nel progetto con id ' + (result.project_id || '') + ' e nome ' + (result.project_name || '')
                        : false);
                });

                const bookingResults = res.data.bookings || {};
                bookingsToCheck.forEach(({ index, type }) => {
                    const key = `${index}_${type}`;
                    const result = bookingResults[key] || { exists: false };
                    const isSameProject = result.exists && this.$route.params.action === 'edit' && String(result.project_id) === String(this.$route.params.id);
                    this.setBeError(index, type, (result.exists && !isSameProject)
                        ? type + ' già usato nel progetto con id ' + (result.project_id || '') + ' e nome ' + (result.project_name || '')
                        : false);
                });
            } catch (err) {
                sitesToCheck.forEach(({ index }) => this.$set(this.siteErrors, index, 'Errore durante la verifica'));
                bookingsToCheck.forEach(({ index, type }) => this.setBeError(index, type, 'Errore durante la verifica'));
                console.error(err);
            }
        },

        createProject() {
            this.$store.dispatch('projectsModule/createProject', { urlToConnect: 'projects/create' }).then(() => {
                this.collapsedScriptTypes = this.scriptTypes.map(st => st.id);
            });

            // valori di default
            const p = this.$store.state.projectsModule.project;
            p.active = 1;
            p.offline_conversion = 0;
            p.disable_drt = 0;
            p.inject_ads = 0;
            p.shadow_banner_website = 0;
            p.shadow_banner_be = 0;
            p.navigation_logs = 0;
            p.accessibility_popup_website = 1;
            p.accessibility_popup_be = 1;
            p.platform = 'cube';
            p.version = 'all-in-one';
            p.consent_mode = 0;
            p.consent_mode_init = '';
            p.consent_mode_marketing = '';
            p.consent_mode_version = 'v1';
            p.requestLogCreate = '/';
            p.requestLogUpade = '/';
        },

        languageSelect(slug) {
            this.$store.dispatch('projectsModule/languageSelect', { slug: slug });
        },

        saveProject() {
            if (this.hasBlockingValidationErrors) {
                alert('Ci sono errori di validazione da correggere prima di salvare. Verifica i campi evidenziati in rosso (nome progetto, siti e booking).');
                return;
            }

            const invalidBooking = this.$store.state.projectsModule.bookings.find(
                booking => !booking.deleted &&
                    !['id_gruppo', 'group_code', 'ermes_group'].includes(booking.type) &&
                    (!booking.idBlastbook || booking.idBlastbook.trim() === '')
            );

            if (invalidBooking) {
                alert('Il campo "BlastbookID" è obbligatorio per tutti i booking.');
                return;
            }

            var parameters = {
                urlToConnect: 'projects',
                methodToConnect: 'post',
                active: this.$store.state.projectsModule.project.active,
                offline_conversion: this.$store.state.projectsModule.project.offline_conversion,
                disable_drt: this.$store.state.projectsModule.project.disable_drt,
                inject_ads: this.$store.state.projectsModule.project.inject_ads,
                shadow_banner_website: this.$store.state.projectsModule.project.shadow_banner_website,
                shadow_banner_be: this.$store.state.projectsModule.project.shadow_banner_be,
                navigation_logs: this.$store.state.projectsModule.project.navigation_logs,
                accessibility_popup_website: this.$store.state.projectsModule.project.accessibility_popup_website,
                accessibility_popup_be: this.$store.state.projectsModule.project.accessibility_popup_be,
                platform: this.$store.state.projectsModule.project.platform,
                project: this.$store.state.projectsModule.project.project,
                version: this.$store.state.projectsModule.project.version,
                consent_mode: this.$store.state.projectsModule.project.consent_mode,
                ads_data_redaction: this.$store.state.projectsModule.project.ads_data_redaction,
                consent_mode_init: this.$store.state.projectsModule.project.consent_mode_init,
                consent_mode_marketing: this.$store.state.projectsModule.project.consent_mode_marketing,
                consent_mode_version: this.$store.state.projectsModule.project.consent_mode_version,
                sites: this.$store.state.projectsModule.sites,
                bookings: this.$store.state.projectsModule.bookings,
                libraries: this.$store.state.projectsModule.libraries,
                scripts: this.$store.state.projectsModule.scripts,
                translations: this.$store.state.projectsModule.translations
            };

            if (this.$route.params.action === 'edit') {
                parameters.urlToConnect = 'projects/' + this.$route.params.id;
                parameters._method = "patch";
            }

            this.$store.dispatch('projectsModule/saveProject', parameters).then((data) => {
                if (this.$route.params.action === 'create') {
                    if (this.hasPermission('Projects', 'edit')) {
                        this.$router.replace("/projects/" + data.id + "/edit");
                    } else {
                        this.$router.replace("/projects");
                    }
                }
            });
        },

        ...mapMutations({
            addSite: 'projectsModule/addSite',
            addBooking: 'projectsModule/addBooking',
            addScript: 'projectsModule/addScript',
        }),

        deleteSite(id) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('projectsModule/deleteSite', id);
            }
        },
        deleteBooking(id) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('projectsModule/deleteBooking', id);
            }
        },
        deleteScript(id) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('projectsModule/deleteScript', id);
            }
        },

        toggleScriptType(id) {
            const index = this.collapsedScriptTypes.indexOf(id)
            if (index === -1) {
                this.collapsedScriptTypes.push(id)
            } else {
                this.collapsedScriptTypes.splice(index, 1)
            }
        },

        getDotStyle(status) {
            let color = 'red';
            if (status == 2) color = 'green';
            else if (status == 1) color = 'orange';

            return {
                width: '10px',
                height: '10px',
                background: color,
                borderRadius: '50%'
            };
        },

        async checkName() {
            if (!this.project.project) {
                this.nameExists = false;
                return;
            }

            try {
                const res = await axios.get('/project-exist', {
                    params: {
                        name: this.project.project
                    }
                });

                this.nameExists = res.data.exists;
            } catch (err) {
                console.error(err);
            }
        },

        async checkSiteExists(site, index) {
            const siteValue = typeof site === 'string' ? site.trim() : '';

            if (!siteValue) {
                this.$set(this.siteErrors, index, false);
                return;
            }

            // Lo stesso dominio può comparire più volte nello stesso progetto:
            // se è già presente in un altro sito della lista, nessun errore e nessuna chiamata API.
            const sameInList = this.sites.some((s, i) =>
                i !== index &&
                !s.deleted &&
                s.site &&
                s.site.trim().toLowerCase() === siteValue.toLowerCase()
            );
            if (sameInList) {
                this.$set(this.siteErrors, index, false);
                return;
            }

            const requestId = (this.siteCheckRequestIds[index] || 0) + 1;
            this.$set(this.siteCheckRequestIds, index, requestId);

            try {
                const res = await axios.get('/site-exist', {
                    params: {
                        site: siteValue
                    }
                });

                if (this.siteCheckRequestIds[index] !== requestId) {
                    return;
                }
                const isSameProject = res.data.exists && this.$route.params.action === 'edit' && String(res.data.project_id) === String(this.$route.params.id);
                this.$set(this.siteErrors, index, (res.data.exists && !isSameProject) ? 'Il dominio ' + siteValue + ' è già usato nel progetto con id ' + (res.data.project_id || '') + ' e nome ' + (res.data.project_name || '') : false);
            } catch (err) {
                if (this.siteCheckRequestIds[index] === requestId) {
                    this.$set(this.siteErrors, index, 'Errore durante la verifica');
                }
                console.error(err);
            }
        },

        clearSiteCheck(index) {
            if (this.siteCheckTimeouts[index]) {
                clearTimeout(this.siteCheckTimeouts[index]);
                this.$delete(this.siteCheckTimeouts, index);
            }
        },

        handleSiteInput(site, index) {
            this.clearSiteCheck(index);
            this.checkSites();

            if (site.deleted || !site.site || site.site.trim() === '') {
                this.$set(this.siteErrors, index, false);
                return;
            }

            this.$set(this.siteCheckTimeouts, index, setTimeout(() => {
                this.checkSiteExists(site.site, index);
                this.$delete(this.siteCheckTimeouts, index);
            }, 100));
        },

        handleBeInput(booking, index, type = "") {
            this.clearBeCheck(index, type);

            const fieldValue = this.getBeFieldValue(booking, type);
            if (booking.deleted || !fieldValue || fieldValue.trim() === '') {
                this.setBeError(index, type, false);
                return;
            }

            this.$set(this.beCheckTimeouts, `${index}_${type}`, setTimeout(() => {
                this.checkBeExists(booking, index, type);
                this.$delete(this.beCheckTimeouts, `${index}_${type}`);
            }, 100));
        },

        getBeFieldValue(booking, type) {
            if (type === 'CrsId') return booking.booking;
            if (type === 'BBID') return booking.idBlastbook;
            if (type === 'ACCID') return booking.accommodationID;
            return null;
        },

        setBeError(index, type, message) {
            const current = this.beErrors[index] || {};
            this.$set(this.beErrors, index, { ...current, [type]: message });
        },

        clearBeCheck(index, type) {
            const key = `${index}_${type}`;
            if (this.beCheckTimeouts[key]) {
                clearTimeout(this.beCheckTimeouts[key]);
                this.$delete(this.beCheckTimeouts, key);
            }
        },

        async checkBeExists(booking, index, type) {
            const key = `${index}_${type}`;
            const requestId = (this.beCheckRequestIds[key] || 0) + 1;
            this.$set(this.beCheckRequestIds, key, requestId);

            const params = { isGroup: GROUP_BOOKING_TYPES.includes(booking.type) };
            if (type === 'CrsId') params.crsId = booking.booking;
            else if (type === 'BBID') params.bbId = booking.idBlastbook;
            else if (type === 'ACCID') params.accId = booking.accommodationID;

            try {
                const res = await axios.get('/booking-exist', { params });

                if (this.beCheckRequestIds[key] !== requestId) {
                    return;
                }
                const isSameProject = res.data.exists && this.$route.params.action === 'edit' && String(res.data.project_id) === String(this.$route.params.id);
                this.setBeError(index, type, (res.data.exists && !isSameProject)
                    ? type + ' già usato nel progetto con id ' + (res.data.project_id || '') + ' e nome ' + (res.data.project_name || '')
                    : false);
            } catch (err) {
                if (this.beCheckRequestIds[key] === requestId) {
                    this.setBeError(index, type, 'Errore durante la verifica');
                }
                console.error(err);
            }
        },

        flushBeCheck(booking, index, type = "") {
            this.clearBeCheck(index, type);

            const fieldValue = this.getBeFieldValue(booking, type);
            if (booking.deleted || !fieldValue || fieldValue.trim() === '') {
                this.setBeError(index, type, false);
                return;
            }

            this.checkBeExists(booking, index, type);
        },

        flushSiteCheck(site, index) {
            this.clearSiteCheck(index);
            this.checkSites();

            if (site.deleted || !site.site || site.site.trim() === '') {
                this.$set(this.siteErrors, index, false);
                return;
            }

            this.checkSiteExists(site.site, index);
        },

        buildSiteDuplicateErrors() {
            // Lo stesso dominio può essere usato più volte nello stesso progetto:
            // non viene segnalato come duplicato. La verifica cross-progetto
            // avviene tramite checkSiteExists (chiamata API).
            return this.sites.map(() => false);
        },

        checkSites() {
            const duplicateErrors = this.buildSiteDuplicateErrors();
            duplicateErrors.forEach((err, index) => {
                if (err === 'Duplicato') {
                    this.$set(this.siteErrors, index, 'Duplicato');
                } else if (this.siteErrors[index] === 'Duplicato') {
                    this.$set(this.siteErrors, index, false);
                }
                // preserva gli errori delle chiamate già presenti
            });
            return duplicateErrors;
        },

        checkNameDebounced: _.debounce(function() {
            this.checkName();
        }, 100),

        checkSiteExistsDebounced: _.debounce(function(site, index) {
            this.checkSiteExists(site, index);
        }, 100),

        siteNameRequiredError(index) {
            const site = this.sites[index];
            return site && !site.deleted && site.folder && site.folder.trim() !== '' && (!site.name || site.name.trim() === '');
        }
    },

    watch: {
        'sites.length'(newLen, oldLen) {
            if (this._isLoadingProject) return;
            if (newLen > oldLen) {
                const updated = { ...this.expandedSites };
                updated[newLen - 1] = true;
                this.expandedSites = updated;
            }
        },

        'bookings.length'(newLen, oldLen) {
            if (this._isLoadingProject) return;
            if (newLen > oldLen) {
                const updated = { ...this.expandedBookings };
                updated[newLen - 1] = true;
                this.expandedBookings = updated;
            }
        },

        sites: {
            deep: true,
            handler() {
                if (window.location.pathname.includes('create')) {
                    this.checkSites();
                }
            }
        },

        scriptTypes: {
            immediate: true,
            handler(newVal) {
                if (Array.isArray(newVal) && newVal.length) {
                    this.collapsedScriptTypes = newVal.map(st => st.id)
                }
            }
        },

        '$route' () {
            if (this.$route.params.action == 'edit') {
                this.loadProject();
            } else if (this.$route.params.action == 'create') {
                this.createProject();
            }
        },

        'project.project'(newVal) {
            if (this.$route.params.action == 'create') {
                this.checkNameDebounced();
            }
        }
    },

    created() {
        if (this.$route.params.action == 'edit') {
            this.loadProject();
        } else if (this.$route.params.action == 'create') {
            this.createProject();
        }
    },

    beforeDestroy() {
        Object.keys(this.siteCheckTimeouts).forEach((index) => {
            this.clearSiteCheck(index);
        });
        Object.keys(this.beCheckTimeouts).forEach((key) => {
            clearTimeout(this.beCheckTimeouts[key]);
        });
    }
};
</script>
